<script setup>
// Gospodarz pytań z useConfirm(): jeden ConfirmDialog na całą aplikację,
// pokazywany, gdy jakiś handler czeka na `await confirm(…)`.
import { computed } from 'vue';
import ConfirmDialog from '@/components/v2/confirm-dialog.vue';
import { confirmState, settleConfirm } from '@/composables/useConfirm.js';

const ask = computed(() => confirmState.value ?? {});
</script>

<template>
    <!-- Własny kontekst warstw ponad wszystkim (też nad oknami PrimeVue, z-index ~1100),
         bo pytanie pada z wnętrza dowolnego modala. -->
    <div class="relative z-[1200]">
    <ConfirmDialog
        :show="!!confirmState"
        :title="ask.title"
        :subject="ask.subject"
        :message="ask.message"
        :confirm-label="ask.confirmLabel"
        @close="settleConfirm(false)"
        @confirm="settleConfirm(true)"
    />
    </div>
</template>
